var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { ChangeDetectorRef, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DocumentType } from '../../../../../../../common/src/bdd/documents/DocumentType';
import { EnumPrestationState } from '../../../../../../../common/src/bdd/interfaces/IPrestation';
import { File } from '../../../../../../../common/src/bdd/prestation/File';
import { Prestation } from '../../../../../../../common/src/bdd/prestation/Prestation';
import { HieroBDD } from '../../../../../services/hierobdd.service';
import { AppModalConfirmComponent } from '../../../../../../../common/src/utility/modal/confirm-modal.component';
import { LocalisationService } from '../../../../../../../common/src/modules/localisation/localisation.service';
var PrestationComponent = /** @class */ (function () {
    function PrestationComponent(hiero, router, route, cdRef, modalService, localisation) {
        this.hiero = hiero;
        this.router = router;
        this.route = route;
        this.cdRef = cdRef;
        this.modalService = modalService;
        this.localisation = localisation;
        this.messages = [];
        this.busy = true;
    }
    PrestationComponent.prototype.ngOnInit = function () {
        var _this = this;
        // Get prestation id from params
        var prestationId = this.route.snapshot.parent.paramMap.get('prestationId');
        // Watch for translator
        this.traducteurSub = this.hiero.WatchTraducteur({
            next: function (traducteur) {
                if (traducteur) {
                    _this.traducteur = traducteur;
                    _this.user = traducteur.User;
                    // Get the specific prestation
                    Prestation.Load(traducteur.User, true, prestationId, true)
                        .then(function (prestation) {
                        // Clean up old one
                        if (_this.prestation) {
                            _this.prestation.cleanup();
                        }
                        if (_this.prestationSub) {
                            _this.prestationSub.unsubscribe();
                        }
                        // Replace with new one
                        _this.prestation = prestation;
                        // Subscribe for modifications
                        _this.prestationSub = _this.prestation.Watch({
                            next: function (updated) {
                                _this.prestation = updated;
                                _this.checkBusy();
                            }
                        });
                        _this.cdRef.detectChanges();
                    });
                    // Listen for document types
                    DocumentType.Init(traducteur.User)
                        .then(function (types) {
                        _this.documentTypeMap = types;
                        _this.checkBusy();
                    });
                }
            }
        });
    };
    PrestationComponent.prototype.checkBusy = function () {
        if (this.prestation && this.documentTypeMap) {
            this.busy = false;
        }
    };
    Object.defineProperty(PrestationComponent.prototype, "haveChatWindow", {
        get: function () {
            if (!this.prestation) {
                return false;
            }
            return (this.prestation.Data.state === EnumPrestationState.Translating ||
                this.prestation.Data.state === EnumPrestationState.WaitingForValidationFromClient ||
                this.prestation.Data.state === EnumPrestationState.Validated);
        },
        enumerable: true,
        configurable: true
    });
    PrestationComponent.prototype.getDocumentName = function (code) {
        if (this.documentTypeMap) {
            return this.documentTypeMap.GetDocumentName(this.localisation.CurrentLanguageISO639, code);
        }
        else {
            return '';
        }
    };
    PrestationComponent.prototype.openFile = function (prestation, document, file) {
        return __awaiter(this, void 0, void 0, function () {
            var fileObj, link, err_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        fileObj = new File(this.hiero.Storage, this.prestation.Data.uid, prestation, document.deviceStorageId, file);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, fileObj.GetDownloadLink()];
                    case 2:
                        link = _a.sent();
                        window.open(link, '_blank');
                        return [3 /*break*/, 4];
                    case 3:
                        err_1 = _a.sent();
                        console.error(err_1);
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    PrestationComponent.prototype.ngOnDestroy = function () {
        if (this.traducteurSub) {
            this.traducteurSub.unsubscribe();
        }
        if (this.prestationSub) {
            this.prestationSub.unsubscribe();
        }
        if (this.prestation) {
            this.prestation.cleanup();
        }
    };
    PrestationComponent.prototype.validate = function () {
        return __awaiter(this, void 0, void 0, function () {
            var modalRef, result, _a, err_2;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        modalRef = this.modalService.open(AppModalConfirmComponent, {
                            centered: true,
                        });
                        modalRef.componentInstance.header = this.localisation.localise('prestation_order_validate_title');
                        modalRef.componentInstance.message = this.localisation.localise('prestation_order_validate_msg');
                        modalRef.componentInstance.ok = this.localisation.localise('prestation_order_confirm_ok');
                        modalRef.componentInstance.cancel = this.localisation.localise('prestation_order_confirm_cancel');
                        result = false;
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, modalRef.result];
                    case 2:
                        result = _b.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        _a = _b.sent();
                        return [3 /*break*/, 4];
                    case 4:
                        if (!result) return [3 /*break*/, 9];
                        this.busy = true;
                        _b.label = 5;
                    case 5:
                        _b.trys.push([5, 7, 8, 9]);
                        return [4 /*yield*/, this.prestation.Validate()];
                    case 6:
                        _b.sent();
                        return [3 /*break*/, 9];
                    case 7:
                        err_2 = _b.sent();
                        console.error(err_2.message);
                        return [3 /*break*/, 9];
                    case 8:
                        this.busy = false;
                        return [7 /*endfinally*/];
                    case 9: return [2 /*return*/];
                }
            });
        });
    };
    PrestationComponent.prototype.translate = function (document) {
        this.router.navigate(['/app', 'prestation', this.prestation.Id, 'document', document.deviceStorageId]);
    };
    Object.defineProperty(PrestationComponent.prototype, "canValidate", {
        get: function () {
            var valid = true;
            this.prestation.Data.documents.forEach(function (doc) {
                if (!doc.translated || doc.translated.length === 0) {
                    valid = false;
                }
            });
            return valid;
        },
        enumerable: true,
        configurable: true
    });
    PrestationComponent.prototype.removeFile = function (document, file) {
        return __awaiter(this, void 0, void 0, function () {
            var err_3;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.busy = true;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, 4, 5]);
                        return [4 /*yield*/, this.prestation.DeleteTranslatedFile(this.hiero.Storage, document, file)];
                    case 2:
                        _a.sent();
                        return [3 /*break*/, 5];
                    case 3:
                        err_3 = _a.sent();
                        console.error(err_3);
                        return [3 /*break*/, 5];
                    case 4:
                        this.busy = false;
                        return [7 /*endfinally*/];
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    PrestationComponent.prototype.accept = function () {
        return __awaiter(this, void 0, void 0, function () {
            var modalRef, result, _a, err_4;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        modalRef = this.modalService.open(AppModalConfirmComponent, {
                            centered: true,
                        });
                        modalRef.componentInstance.header = this.localisation.localise('prestation_order_accept_title');
                        modalRef.componentInstance.message = this.localisation.localise('prestation_order_accept_msg');
                        modalRef.componentInstance.ok = this.localisation.localise('prestation_order_confirm_ok');
                        modalRef.componentInstance.cancel = this.localisation.localise('prestation_order_confirm_cancel');
                        result = false;
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, modalRef.result];
                    case 2:
                        result = _b.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        _a = _b.sent();
                        return [3 /*break*/, 4];
                    case 4:
                        if (!result) return [3 /*break*/, 9];
                        this.busy = true;
                        _b.label = 5;
                    case 5:
                        _b.trys.push([5, 7, 8, 9]);
                        return [4 /*yield*/, this.prestation.AcceptPrestation()];
                    case 6:
                        _b.sent();
                        return [3 /*break*/, 9];
                    case 7:
                        err_4 = _b.sent();
                        console.error(err_4.message);
                        return [3 /*break*/, 9];
                    case 8:
                        this.busy = false;
                        return [7 /*endfinally*/];
                    case 9: return [2 /*return*/];
                }
            });
        });
    };
    PrestationComponent.prototype.refuse = function () {
        return __awaiter(this, void 0, void 0, function () {
            var modalRef, result, _a, err_5;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        modalRef = this.modalService.open(AppModalConfirmComponent, {
                            centered: true,
                        });
                        modalRef.componentInstance.header = this.localisation.localise('prestation_order_refuse_title');
                        modalRef.componentInstance.message = this.localisation.localise('prestation_order_refuse_msg');
                        modalRef.componentInstance.ok = this.localisation.localise('prestation_order_confirm_ok');
                        modalRef.componentInstance.cancel = this.localisation.localise('prestation_order_confirm_cancel');
                        result = false;
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, modalRef.result];
                    case 2:
                        result = _b.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        _a = _b.sent();
                        return [3 /*break*/, 4];
                    case 4:
                        if (!result) return [3 /*break*/, 9];
                        this.busy = true;
                        _b.label = 5;
                    case 5:
                        _b.trys.push([5, 7, 8, 9]);
                        return [4 /*yield*/, this.prestation.RefusePrestation()];
                    case 6:
                        _b.sent();
                        return [3 /*break*/, 9];
                    case 7:
                        err_5 = _b.sent();
                        console.error(err_5.message);
                        return [3 /*break*/, 9];
                    case 8:
                        this.busy = false;
                        return [7 /*endfinally*/];
                    case 9: return [2 /*return*/];
                }
            });
        });
    };
    return PrestationComponent;
}());
export { PrestationComponent };
